var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visability('group'))?_c('div',{style:({..._vm.backgroundColor, ..._vm.padding, ..._vm.shadow})},[_c('div',{staticClass:"image-background",style:({..._vm.backgroundImage})}),_c('div',{class:_vm.container},[_c('div',{staticClass:"video-item-3"},[_c('b-row',[_vm._t("default")],2)],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }